import { motion } from "framer-motion";
import { Car, Box, FileCheck2, Sparkles, Target } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { ServiceMethod } from "@/components/landing/ServiceMethod";
import { ServiceCollaboration } from "@/components/landing/ServiceCollaboration";

const icons = [Car, Box, Sparkles, FileCheck2, Target];
const serviceSlugs = ["car-design", "product-design", "ai-driven-design", "patent-consulting", "brand-product-strategy"];

export const Services = () => {
  const { t } = useLang();

  return (
    <section
      id="services"
      data-testid="services-section"
      className="relative bg-[#0A0A0E] py-24 md:py-32 lg:py-40 border-y border-white/5"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-12">
        <div className="max-w-2xl">
          <p className="font-mono text-xs tracking-[0.2em] uppercase font-bold text-zinc-500">
            {t.services.overline}
          </p>
          <h2 className="mt-5 font-heading text-3xl sm:text-4xl tracking-tight font-medium text-white">
            {t.services.title}
          </h2>
        </div>

        <div className="mt-14 grid gap-6 md:grid-cols-2 xl:grid-cols-5">
          {t.services.items.map((item, i) => {
            const Icon = icons[i];
            const slug = serviceSlugs[i];
            return (
              <motion.div
                key={item.title}
                data-testid={`service-card-${slug}`}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.3 }}
                transition={{
                  duration: 0.6,
                  ease: [0.22, 1, 0.36, 1],
                  delay: i * 0.12,
                }}
                className="group relative bg-[#050507] border border-white/5 rounded-xl p-8 hover:border-[#00F0FF]/30 transition-colors duration-500"
              >
                <div className="absolute inset-0 rounded-xl opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none bg-[radial-gradient(400px_circle_at_top,rgba(0,240,255,0.08),transparent)]" />
                <div className="relative">
                  <div className="inline-flex h-12 w-12 items-center justify-center rounded-lg border border-white/10 bg-white/5 text-[#00F0FF]">
                    <Icon className="h-6 w-6" />
                  </div>
                  <h3 className="mt-6 font-heading text-xl font-medium text-white">
                    {item.title}
                  </h3>
                  <p className="mt-3 text-sm leading-relaxed text-zinc-400">
                    {item.desc}
                  </p>
                  <div className="mt-6 font-mono text-xs text-zinc-600">
                    0{i + 1}
                  </div>
                </div>
              </motion.div>
            );
          })}
        </div>

        <ServiceMethod />
        <ServiceCollaboration />
      </div>
    </section>
  );
};
